import axios from 'axios'

export function getMenuItems(locale) {
  return axios({ method: 'GET', url: 'api/sales-static/menu-items', params: { locale } })
}
